require([
    'CiBriage'
    , 'lang'
    , 'app/NoSupport'
    , 'app/DownApp'
], function (
    CiBriage
    , SnapLang
    , NoSupport
    , DownApp
) {
        //初始化ci集成内容
    CiBriage.init();

    //初始化语言包
    var snapLang = window.snapLang = new SnapLang();

    snapLang.install(function () {
        console.log("lang is installed")
        //设置页面标题
        var downApp = window.downApp = new DownApp();
        var noSupport = window.noSupport = new NoSupport();
        if (noSupport.test() === false) {
            setTimeout(function () {
                if (window.downApp) {
                    window.downApp.viewModel.show(true);
                }
            }, 500);
        } else {
            require([
                'app/App'
                , 'app/AppStore'
                , 'app/AppRouterManager'//路由管理器
                , 'app/Login'
                , 'app/ReLogin'
                , 'WindowPostMessage'
                , 'RequestCollection'
                , 'LangChooseDialog'
                , 'app/InfoDailog'
            ], function (
                SnapApp
                , AppStore
                , AppRouterManager
                , Login
                , ReLogin
                , WindowPostMessage
                , RequestCollection
                , LangChooseDialog
                , InfoDailog
            ) {
                    //初始化全局store
                    window.store = new AppStore();
                    //初始化approuter
                    window.appRouterManager = new AppRouterManager();
                    //初始化多语言选择对话框
                    window.langChooseDialog = new LangChooseDialog();
                    //初始化登陆
                    window.login = new Login();
                    //定义全局的store
                    var autoLogin = window.globeFormPageConfig.autoLogin;
                    if (autoLogin === true) {
                        window.reLogin = new ReLogin();
                    }
                    //创建app实例
                    window.app = new SnapApp({
                        viewTemplate: 'default'
                    });

                    if (window.globeFormPageConfig.nestedMode === true) {
                        $(document.body).css("background", "transparent");
                    }
                    //验证notice
                    RequestCollection.verifyLicense();
                    //InfoDailog页面
                    if(window.globeFormPageConfig.oaInfo === true){
                        app.infoDailog = new InfoDailog();
                    }
                });
        }
        $("div.snap-pageloading").hide();
    });
});
